<template>
  <div class="content_box">
    <van-dropdown-menu style="position:fixed;top:0;width:100%;z-index:99;" >
      <van-dropdown-item v-model="category" :options="options" @change="queryPostListByPage(1)"/>
    </van-dropdown-menu>
    <div style="padding-top:60px; padding-bottom: 60px;">
      <!-- <van-pull-refresh v-model="loading" @refresh="queryPostListByPage(1)" style="height: 100%;"> -->
        <div class="card" v-for="item in dataItems" :key="item.id" @click="toDetail(item.id)">
          <div class="card_title">{{item.title}}</div>
          <div class="card_content">{{item.postContentTxt}}</div>
          <div class="card-foot">
            <div class="card_time">{{item.submitTime}}</div>
            <div class="card_category">{{item.categoryName}}</div>
          </div>
        </div>
      <!-- </van-pull-refresh> -->
      <div
        v-if="page.currentPage >= page.pages"
        style="font-size: 0.24rem;color: #cecece;text-align: center; margin-top: 10px;"
      >暂时没有更多了</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon } from "vant";
Vue.use(Icon);
import { Notify } from "vant";
import { queryPostListByPage,queryDataCodeListByTypeid } from "@/api/user.js";
export default {
  data() {
    return {
      category: '-1',
      options:[],
      page: {
        currentPage: 1,
        pageSize: 10
      },
      loading: false,
      dataItems:[],
      canScroll: true,
    };
  },
  created() {
    this.queryPostListByPage(1);
    this.queryDataCodeListByTypeid();
  },
  mounted() {
    var vm = this;
    window.onscroll = function() {
      //获得页面向左、向上卷动的距离
      function getScroll() {
        return {
          left:
            window.pageXOffset ||
            document.documentElement.scrollLeft ||
            document.body.scrollLeft ||
            0,
          top:
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0
        };
      }
      var sTop = getScroll().top;
      if (sTop + window.innerHeight >= document.body.offsetHeight + 1700) {
        if (vm.canScroll) {
          vm.queryPostListByPage( vm.page.currentPage + 1);
        }
      }
    };
  },
  methods: {
    queryPostListByPage(currentPage) {
      this.canScroll = false;
      if(currentPage == 1) {
        this.dataItems = [];
      }

      var params = {
        category: this.category == '-1' ? "" : this.category, 
        currentPage: currentPage ? currentPage : 1, 
        pageSize: this.page.pageSize
      }

      queryPostListByPage(params).then((res) => {
        if (res.data.status == 200) {
          res.data.object.forEach(item=>{
            this.dataItems.push(item);
          });
          this.page = res.data.page;
          this.loading = false;
          this.canScroll =  this.page.currentPage < this.page.pages;
        } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });
    },
    queryDataCodeListByTypeid() {
      this.options = [{
        text: "全部",
        value: '-1'
      }];
      queryDataCodeListByTypeid("WECHAT_MESSAGE").then((res) => {
        if (res.data.status == 200) {
          res.data.object.forEach(item=> {
            this.options.push({
              text: item.dvalue,
              value: item.svalue
            })
          });
        } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });
    },
    toDetail(id) {
      this.$router.push({
        path: `/tcmr/postDetail?id=${id}`
      });
    }
  },
};
</script>

<style scoped>
.body_box {
  padding: 0.15rem;
}

.content_box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  background: #f7f7f7;
}

.card {
  padding: 0.25rem;
  margin: 0.25rem;
  background: white;
  border-radius: 5px;
}

.card_title{
  font-size: 0.3rem;
  text-align: left;
  margin-bottom: 0.2rem;
}

.card_content{
  font-size: 0.23rem;
  text-align: left;
  color: #939393;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

}

.card-foot {
  position: relative;
  padding: 0.15rem 0 0.3rem;
}

.card_time {
  position: absolute;
  left: 0;
  font-size: 0.2rem;
  text-align: left;
  color: #939393;
}

.card_category {
  position: absolute;
  right: 0;
  font-size: 0.2rem;
  text-align: right;
  color: #939393;
}
</style>